import { Text } from '@/ui-kit'
import { useLingui } from '@lingui/react/macro'
import clsx from 'clsx'
import { Clock } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

type AssessmentCountdownProps = {
  expiresAt: string
  onExpired?: () => void
}

export const AssessmentCountdown = ({ expiresAt, onExpired }: AssessmentCountdownProps) => {
  const { t } = useLingui()
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000))
  )
  const firedRef = useRef(false)
  const onExpiredRef = useRef(onExpired)
  onExpiredRef.current = onExpired

  useEffect(() => {
    firedRef.current = false
    const tick = () => {
      const secs = Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000))
      setRemaining(secs)
      if (secs <= 0 && !firedRef.current) {
        firedRef.current = true
        onExpiredRef.current?.()
        clearInterval(id)
      }
    }
    const id = setInterval(tick, 1000)
    tick()
    return () => clearInterval(id)
  }, [expiresAt])

  const mins = Math.floor(remaining / 60)
  const secs = remaining % 60
  const expired = remaining <= 0
  const urgent = remaining <= 120

  return (
    <Text
      type="body3-regular"
      className={clsx(
        'flex items-center gap-1 font-mono',
        expired ? 'text-red' : urgent ? 'text-orange' : 'text-gray-80'
      )}
    >
      <Clock className="size-3.5" />
      {expired ? t`Time's up` : `${mins}:${secs.toString().padStart(2, '0')}`}
    </Text>
  )
}
